<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Segments' commercial stories
            </v-row>
            <v-divider />
            <!--table head-->
            <v-row class="subtitle-2" no-gutters>
                <v-col class="tabCell text-left">
                    Segments' weights (segment name - segment weight)
                </v-col>
                <v-divider vertical />
                <v-col class="tabCell text-center px-1">
                    Text
                </v-col>
                <v-divider vertical />
                <v-col class="tabCell text-center" cols="1">
                    Actions
                </v-col>
            </v-row>

            <div v-if="commercial_stories?.length">
                <!--commercial stories tab-->
                <v-row v-for="story in commercial_stories" :key="story.id" no-gutters>
                    <v-col class="tabCell text-center">
                        <span v-for="(name, idx) in story.names" :key="idx" class="mr-2">
                            {{ name }} - {{ story.weights[idx]}}
                        </span>
                    </v-col>
                    <v-divider vertical />
                    <v-col class="tabCell text-center px-1">{{ story.text }}</v-col>
                    <v-divider vertical />
                    <v-col cols="1" class="tabCell text-center">
                        <edit-commercial-story :story="story" />
                        <delete-commercial-story :story="story" />
                    </v-col>
                </v-row>
            </div>
            <v-row v-else class="mt-4" justify="center">
                there are no stories yet
            </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>

import EditCommercialStory from '../../../components/admin/commercial-story/editCommercialStory.vue'
import DeleteCommercialStory from '../../../components/admin/commercial-story/deleteCommercialStory.vue'
import Loader from '../../../layouts/Loader.vue'

export default {
    data() {
        return {}
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        commercial_stories() {
            return this.$store.getters.commercial_stories;
        }
    },
    methods: {
        localeNumber(num) {
            if (num) {
                    if (this.locale == 'ro-RO') {
                    return num.toLocaleString('en-US')
                }
                return num.toLocaleString(this.locale)
            }
            return 0;
        },  
    },
    components: {
        Loader, EditCommercialStory, DeleteCommercialStory
    }
}
</script>


		
